/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [' .trim {\n     margin-right: 20%;\n }\n \n \n \n \n \n .shortlink {\n     font-size: small;\n }\n \n .author {\n     color: black;\n     font-size: small;\n }\n \n .error {\n     color: red;\n     font-size: small\n }\n \n .borderless {\n     border: None;\n }\n \n .new-icon {\n     text-decoration: None;\n     color: red;\n }\n \n .open-new-window-icon {\n     vertical-align: middle;\n }\n \n .search-term {\n     font-weight: bold;\n }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2hvbWUvc2VhcmNoL3NlYXJjaC5jb21wb25lbnQuY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzk0NjMyOTQ3MC9zcmMvZnJvbnRlbmQvc3JjL2FwcC9ob21lL3NlYXJjaC9zZWFyY2guY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/home/search/search.component.css.ngstyle.ts